module.exports = __webpack_public_path__ + "assets/img/register_date-7a6e1a29.png";